export const getConcatenatedIdsList = (nodes) => {
  return nodes.map((node) => node.data?.['@id']).join(',');
};
export const getReferencedConnectorIDsList = (node) => {
  const connectorIds = node?.data?.['@ref-connector-id']?.split(',') || [];
  return connectorIds;
};

export const getReferencedDataframeIDsList = (node) => {
  const dataframeIds = node?.data?.['@ref-dataframe-id']?.split(',') || [];
  return dataframeIds;
};

export const addReferencedConnectorID = (node, connectorId) => {
  const connectorIds = getReferencedConnectorIDsList(node);
  if (!connectorIds.includes(connectorId)) {
    connectorIds.push(connectorId);
    node.data['@ref-connector-id'] = connectorIds.join(',');
  }
  return node;
};

export const addReferencedDataframeID = (node, dataframeId) => {
  const dataframeIds = getReferencedDataframeIDsList(node);
  if (!dataframeIds.includes(dataframeId)) {
    dataframeIds.push(dataframeId);
    node.data['@ref-dataframe-id'] = dataframeIds.join(',');
  }
  return node;
};

export const removeReferencedConnectorID = (node, connectorId) => {
  const connectorIds = getReferencedConnectorIDsList(node);
  const newConnectorIds = connectorIds.filter((id) => id !== connectorId);
  node.data['@ref-connector-id'] = newConnectorIds.join(',');
  return node;
};

export const removeReferencedDataframeID = (node, dataframeId) => {
  const dataframeIds = getReferencedDataframeIDsList(node);
  const newDataframeIds = dataframeIds.filter((id) => id !== dataframeId);
  node.data['@ref-dataframe-id'] = newDataframeIds.join(',');
  return node;
};

export const removeReferencedID = (node, id) => {
  const connectorIds = getReferencedConnectorIDsList(node);
  const dataframeIds = getReferencedDataframeIDsList(node);

  if (connectorIds.includes(id)) {
    return removeReferencedConnectorID(node, id);
  }
  if (dataframeIds.includes(id)) {
    return removeReferencedDataframeID(node, id);
  }
  return node;
};
